"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _color = _interopRequireDefault(require("color"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/* eslint-disable global-require */
var _default = {
  name: '3D',
  audioOnClassName: _style["default"].audioOn,
  audioOffClassName: _style["default"].audioOff,
  renderButton: function renderButton(_ref) {
    var type = _ref.type,
      onClick = _ref.onClick,
      title = _ref.title,
      color = _ref.color;
    var darkenColor = (0, _color["default"])(color).darken(0.1).hex();
    var svg = /*#__PURE__*/_react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "563.26",
      height: "92.47",
      viewBox: "-375.53 53.26 563.26 92.47"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      opacity: ".2",
      d: "M137.4 60.44h-504.27a6.08 6.08 0 0 0-6.08 6.08v73.13a6.08 6.08 0 0 0 6.08 6.08H137.4c1.41 0 2.78-.5 3.87-1.4l44.28-36.56a6.06 6.06 0 0 0 0-9.33l-44.28-36.62a6.23 6.23 0 0 0-3.87-1.38z"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: "#FFF",
      stroke: color,
      strokeWidth: "2.06",
      strokeMiterlimit: "10",
      d: "M135.84 54.29h-504.26a6.08 6.08 0 0 0-6.08 6.07v73.14a6.08 6.08 0 0 0 6.08 6.06h504.26c1.4 0 2.78-.49 3.87-1.38l44.28-36.58a6.05 6.05 0 0 0 0-9.33l-44.28-36.6a6.05 6.05 0 0 0-3.87-1.38z"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: color,
      d: "M134.08 62.04H-362a4.5 4.5 0 0 0-4.51 4.51v60.74a4.5 4.5 0 0 0 4.5 4.51h496.09l42.25-34.88-42.25-34.88z"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fill: darkenColor,
      d: "M176.33 96.92h-542.86v30.44c.01 2.45 2 4.44 4.46 4.44h496.15l42.25-34.88z"
    }));
    return /*#__PURE__*/_react["default"].createElement("a", {
      className: type === 'prev' ? _style["default"].prevButton : _style["default"].nextButton,
      onClick: onClick
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].leftPart
    }, svg), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].rightPart
    }, svg), title);
  },
  assets: [require('./audioOff.svg'), require('./audioOn.svg')]
};
exports["default"] = _default;